import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans } from 'react-i18next';

import * as S from './styled';

interface IWorkoutTitle {
    title: string;
    subtitle: string;
    name?: string;
}

export const WorkoutTitle = ({ title, subtitle, name }: IWorkoutTitle) => {
    return (
        <>
            <S.Title type="h5" mb={12}>
                {name ? name : <Trans i18nKey={title} />}
            </S.Title>
            <Text type="medium-text" color="text-secondary">
                <Trans i18nKey={subtitle} />
            </Text>
        </>
    );
};
